import { Box } from '@mui/material';

import { boardCardColors } from '../card-actions/utils/cardColors';
import { inlineMenuPopoutSx } from './inlineMenuStyles';

interface InlineColorMenuProps {
  currentColor: string;
  onSelect: (color: string) => void;
}

export function InlineColorMenu({ currentColor, onSelect }: InlineColorMenuProps) {
  return (
    <Box
      sx={{
        ...inlineMenuPopoutSx,
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: 1,
        p: 1,
        width: 314,
      }}
    >
      {boardCardColors.map((color) => (
        <Box
          aria-label={`Set color ${color}`}
          component="button"
          key={color}
          onClick={() => onSelect(color)}
          sx={{
            bgcolor: color,
            border:
              color.toLowerCase() === currentColor?.toLowerCase()
                ? '1px solid #666'
                : '1px solid #dddddd',
            cursor: 'pointer',
            borderRadius: '50%',
            height: 30,
            p: 0,
            width: 30,
          }}
        />
      ))}
    </Box>
  );
}
